<!--
 * @Author: 范向玲
 * @Date: 2022-12-20 17:36:14
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-05-31 13:43:45
 * @Description: 文件上传
 * @FilePath: \web\src\components\lib\Upload\fileUploadMarket.vue
-->
<template>
  <section class="file-upload-container">
    <a-spin :spinning="spinning" tip="文件上传中">
      <a-upload v-model:file-list="optionConf.fileList" name="file" accept=".pdf" :showUploadList="true"
        @change="handleChange" :before-upload="beforeUpload">
        <a-button>文件上传</a-button>
      </a-upload>
    </a-spin>
  </section>
</template>

<script setup>
import { ref, reactive, defineEmits, watch, defineProps, onMounted, onBeforeMount, } from 'vue';
import { message } from 'ant-design-vue';
import { importApi } from '@/api/Portal/marketApi';

const props = defineProps({
  uploadType: {
    type: String,
  },
  fileListProps: {
    type: Array,
  },
});
const spinning = ref(false)
// emit
const emit = defineEmits(['fileList',]);

const optionConf = reactive({
  fileList: [],
});

/**
 * @description 阻止选择文件自动上传
 */
const beforeUpload = (file) => {
  return false;
};


const xlsxUpload = fileList => {
  if (fileList && fileList.length > 0) {
    let formData = new FormData();

    let list = fileList;

    list.forEach((file) => {
      formData.append('file', file);
    });
    spinning.value = true
    importApi(formData).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        if (res.data.code === 200) {
          emit('fileList', { fileList: optionConf.fileList, id: res.data.msg });
        } else {
          message.error('导入失败！');
        }
        spinning.value = false;
      }
    });
  }
};

/**
 * @description 导入文件修改
 */
const handleChange = (info) => {
  // eslint-disable-next-line eqeqeq
  // console.log(info.file, 'application/pdf')
  if (info.file.status === "removed") {
    const index = optionConf.fileList.indexOf(info.file);
    const newFileList = optionConf.fileList.slice();

    newFileList.splice(index, 1);
    optionConf.fileList = newFileList;
    return;
  }
  if (info.file.status != "removed" && info.file.type != 'application/pdf') {
    message.error('上传文件格式错误！');
    optionConf.fileList = [];
    return;
  }
  optionConf.fileList = [info.file]
  optionConf.fileList = optionConf.fileList.map(file => {
    if (file.response && file.response.data) {
      file.url = file.response.data.absolute_path;
    } else if (file.response && file.response.code !== 200 && file.response.errors.length > 0) {
      file.status = 'error';
      file.name = file.response.errors[0];
    } else if (file.status === 'error') {
      file.name = '[上传失败]';
    }
    return file;
  });
  xlsxUpload(optionConf.fileList)


  // emit('fileList', optionConf.fileList);

};

watch(() => props.fileListProps,
  (val) => {
    if (val.length > 0 && val[0].name) {
      optionConf.fileList = JSON.parse(JSON.stringify(val));
    }
  },
  {
    immediate: true,
    deep: true,
  }
);
</script>

<style lang="scss">
.file-upload-container {
  .ant-upload-list-item-name {
    padding-left: 0;
    color: #fff;
  }

  // 文件列表悬浮样式修改
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: rgba(140, 100, 30, .4);
  }

  .ant-upload-list-item-card-actions .anticon {
    color: #fff;
  }

  .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
    color: red;
  }
}
</style>